"use strict";
/**
 * @file 类型文件
 * @author Auto Generated by CommonFile
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorDescription = exports.defaultIconConfig = exports.currentColor = void 0;
;
;
/** currentColor 字符串 */
exports.currentColor = 'currentColor';
/** 默认图标配置 */
exports.defaultIconConfig = {
    size: '1em',
    type: 'outline',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    colors: {
        outline: {
            background: 'none',
        },
        filled: {
            background: '#FFF',
        },
        twoTone: {
            stroke: '#333',
            fill: '#2F88FF',
        },
        multiColor: {
            outStroke: '#333',
            outFill: '#2F88FF',
            innerStroke: '#FFF',
            innerFill: '#43CCF8',
        },
    },
};
/**
 * 获取图标颜色描述
 * @param colorProp 颜色配置
 * @param iconType 图标类型
 */
var getColorDescription = function (colorProp, iconType) {
    var color = typeof colorProp === 'string' ? [colorProp] : colorProp || [];
    var colorDesc = [exports.currentColor, exports.currentColor, exports.currentColor, exports.currentColor];
    switch (iconType) {
        case 'outline': {
            colorDesc[0] = typeof color[0] === 'string' ? color[0] : exports.currentColor;
            colorDesc[1] = 'none';
            colorDesc[2] = typeof color[0] === 'string' ? color[0] : exports.currentColor;
            colorDesc[3] = 'none';
            break;
        }
        case 'filled': {
            colorDesc[0] = typeof color[0] === 'string' ? color[0] : exports.currentColor;
            colorDesc[1] = typeof color[0] === 'string' ? color[0] : exports.currentColor;
            colorDesc[2] = '#FFF';
            colorDesc[3] = '#FFF';
            break;
        }
        case 'two-tone': {
            var _a = exports.defaultIconConfig.colors.twoTone, stroke = _a.stroke, fill = _a.fill;
            colorDesc[0] = typeof color[0] === 'string' ? color[0] : stroke;
            colorDesc[1] = typeof color[1] === 'string' ? color[1] : fill;
            colorDesc[2] = typeof color[0] === 'string' ? color[0] : stroke;
            colorDesc[3] = typeof color[1] === 'string' ? color[1] : fill;
            break;
        }
        case 'multi-color': {
            var _b = exports.defaultIconConfig.colors.multiColor, outStroke = _b.outStroke, outFill = _b.outFill, innerStroke = _b.innerStroke, innerFill = _b.innerFill;
            colorDesc[0] = typeof color[0] === 'string' ? color[0] : outStroke;
            colorDesc[1] = typeof color[1] === 'string' ? color[1] : outFill;
            colorDesc[2] = typeof color[2] === 'string' ? color[2] : innerStroke;
            colorDesc[3] = typeof color[3] === 'string' ? color[3] : innerFill;
            break;
        }
    }
    return colorDesc;
};
exports.getColorDescription = getColorDescription;
